// extracted by mini-css-extract-plugin
export var rowLabel = "RowLabel-module--row-label--2pQ6_";